import React from 'react';
import dqPreview from '../assets/dqcoffee-preview.png';
import habitatPreview from '../assets/HabitatTracker-preview.png';
import mononitesPreview from '../assets/Mononites-preview.png';

const PROJECTS = [
  {
    preview: dqPreview,
    tag: 'Branding · Web · Full-Stack',
    title: 'DQ COFFEE',
    sub: 'Premium Coffee Experience',
    desc: 'A full-fledged digital brand experience — immersive landing page, product showcase, and seamless ordering flow built with performance and elegance at its core.',
    stack: ['React', 'Node.js', 'MongoDB', 'Tailwind CSS'],
    url: 'https://dqcoffee.in',
    domain: 'dqcoffee.in',
    previewRight: false,
    upcoming: false,
  },
  {
    preview: habitatPreview,
    tag: 'AI · Sustainability',
    title: 'HABITAT TRACKER',
    sub: 'Korsha Environmental Intelligence',
    desc: 'An intelligent habitat monitoring platform tracking environmental data in real-time with AI-driven insights, live dashboards, and smart alert systems.',
    stack: ['React', 'Node.js', 'Firebase', 'Netlify'],
    url: 'https://korshahabitattracker.vercel.app/',
    domain: 'korshahabitattracker.vercel.app',
    previewRight: true,
    upcoming: false,
  },
  {
    preview: mononitesPreview,
    tag: 'Cloud Kitchen · Corporate Dining',
    title: 'MONONITES',
    sub: 'Smart Corporate Cloud Kitchen',
    desc: 'A next-generation cloud kitchen platform designed to streamline corporate dining — offering curated meal plans, bulk ordering, real-time tracking, and seamless delivery for offices and enterprise teams.',
    stack: ['React', 'Tailwind CSS', 'GitHub'],
    url: 'https://mononites.com',
    domain: 'mononites.com',
    previewRight: false,
    upcoming: false,
  },
];

const Projects = () => (
  <section id="projects">
    <div className="container">
      <div className="projects-header">
        <div>
          <span className="section-tag">Our Work</span>
          <h2 className="section-title">
            SHIPPED &amp;<br />
            <span className="gradient-text">LIVE</span>
          </h2>
          <div className="glow-line" />
          <p className="section-subtitle">
            Real products, real users. Every project is deployed, live, and solving a genuine problem.
          </p>
        </div>
        <div className="count-badge">
          <span className="big-num">10+</span>
          <span className="big-label">Projects<br />Delivered</span>
        </div>
      </div>

      <div className="projects-list">
        {PROJECTS.map(({ preview, tag, title, sub, desc, stack, url, domain, previewRight, upcoming }) => (
          <div key={title} className={`glass-card project-card${previewRight ? ' project-card--reverse' : ''}`}>
            {upcoming ? (
              <div className={`project-visual project-visual--link project-visual--upcoming`} style={{ cursor: 'default' }}>
                <span className="project-preview-label">Preview</span>
                <img
                  src={preview}
                  alt={`${title} preview`}
                  className="project-preview-img project-preview-img--blurred"
                />
                <div className="project-status project-status--upcoming">
                  <span className="upcoming-dot" />
                  Upcoming
                </div>
                <div className="upcoming-overlay">
                  <span className="upcoming-overlay-text">Coming Soon</span>
                </div>
              </div>
            ) : (
              <a
                href={url}
                target="_blank"
                rel="noreferrer"
                className="project-visual project-visual--link"
              >
                <span className="project-preview-label">Preview</span>
                <img
                  src={preview}
                  alt={`${title} preview`}
                  className="project-preview-img"
                />
                <div className="project-status">
                  <span className="live-dot" />
                  Live
                </div>
              </a>
            )}
            <div className="project-content">
              <div className="project-tag">{tag}</div>
              <h3 className="project-title">{title}</h3>
              <p className="project-sub">{sub}</p>
              <p className="project-desc">{desc}</p>
              <div className="stack-pills">
                {stack.map(s => <span key={s} className="stack-pill">{s}</span>)}
              </div>
              <div className="project-links">
                {upcoming ? (
                  <span className="btn-primary project-btn project-btn--disabled">Coming Soon</span>
                ) : (
                  <a href={url} target="_blank" rel="noreferrer" className="btn-primary project-btn">
                    Visit Live Site ↗
                  </a>
                )}
                <span className="project-domain">{domain}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="projects-more">
        <div className="more-line" />
        <div className="more-center">
          <span className="more-text">More projects in progress</span>
          <div className="more-dots">
            <span /><span /><span />
          </div>
        </div>
        <div className="more-line" />
      </div>
    </div>
  </section>
);

export default Projects;
